import {
  Dialog,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPassLogHistory } from "src/features/passLogSlice";
import EnhancedDialogTitle from "../enhanced/EnhancedDialogTitle";
import {fetchPriceListByMassageType} from "../../features/pricingSlice";

function PriceHistoryDialog(props) {
  const classes = useStyles();
  const { open, setOpenHistory, massageType } = props;
  const dispatch = useDispatch();
  const priceHistoryList = useSelector((state) => state.pricing.massagePriceList);
  console.log("priceHistoryList: ", priceHistoryList);

  const handleClose = () => {
    setOpenHistory(false);
  };

  useEffect(() => {
    if (typeof massageType.id !== "undefined") {
      dispatch(fetchPriceListByMassageType(massageType.id));
    }
  }, [massageType, dispatch]);

  return (
    <div className={classes.root}>
      <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="md" aria-labelledby="form-dialog-title">
        <EnhancedDialogTitle handleClose={handleClose} nameLabel="Historie permanentky" />
        <DialogContent>
          <TableContainer>
            {priceHistoryList.length === 0 ? null : (
              <Table aria-label="passlog table">
                <TableHead>
                  <TableRow>
                    <TableCell align="right">Cena</TableCell>
                    <TableCell align="right">Stav</TableCell>
                    <TableCell align="right">Vytvořeno</TableCell>
                    <TableCell align="right">Vytvořil</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {priceHistoryList.map((p, i) => (
                    <TableRow key={i}>
                      <TableCell align="right">{p.price}</TableCell>
                      <TableCell align="right">{p.active === true ? 'Aktivní' : 'Neaktivní' }</TableCell>
                      <TableCell align="right">{ (new Date(p.vytvoreno['date'])).toLocaleString() }</TableCell>
                      <TableCell align="right">{p.vytvoril['fullname']}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </TableContainer>
        </DialogContent>
      </Dialog>
    </div>
  );
}
//<TableCell align="right">{p.vytvoreno['date'].format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                      //<TableCell align="right">{p.vytvoreno.format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                      //<TableCell align="right">{DateTime(p.vytvoreno).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                      //<TableCell align="right">{\DateTime(p.vytvoreno).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
// (new Date(p.vytvoreno['date'])).toLocaleDateTimeString()
// (new DateTime(p.vytvoreno['date'])).toLocaleDateTimeString()

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  }
}));

export default PriceHistoryDialog;
